<template>
  <div class="mic-com rich-text" :style="{backgroundColor: config.background_color}">
    <Description :data="config.content"/>
  </div>
</template>

<script>
  import Common from '../mixins/Common';
  import Description from './Description';

  export default {
	name: 'RichText',
	props: {},
	mixins: [Common],
	components: {Description},
	data() {
	  return {
		blinkFlag: true
	  };
	},
	created() {
	},
	methods: {
	  onChange() {
		console.log('change');
		this.blinkFlag = false;
		this.$nextTick(() => {
		  this.blinkFlag = true;
		});
	  }
	},
	watch: {}
  };
</script>

<style lang="less" rel="stylesheet/less">

  .rich-text {
  }
</style>
